module.exports = __webpack_public_path__ + "static/img/Stroll.ac1dc03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Stroll.jpg
// module id = Atx/
// module chunks = 1